import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import * as _ from 'lodash';
import {getOutageQuestionData} from "../../../../../store/reducers/questions/outageQuestion";
import {IAnswer, IOutage, IQuestion} from "../../../../../data/data";
import {VoiceOver} from "../../../../common/VoiceOver";
import {clearOutageID, setOutageID} from "../../../../../store/actions/outages";
import {hideModal} from "../../../../../store/actions/modals";
import {getOutageData} from "../../../../../store/reducers/outage";
import HighlightText from "../../../../common/highlight-text/HighlightText";

interface QuestionProps
{
    outage: IOutage;
    question: IQuestion;
    clearOutageID: () => void;
    hideModal: () => void;
}

interface QuestionState
{
    answer: number;
    answered: boolean;
    height: number;
}

import * as styles from './Question.scss';
import Button from "../../../../common/ui/button/Button";

const initial_state: QuestionState =
    {
        answer: null,
        answered: false,
        height: null
    };

class OutageQuestion extends React.Component<QuestionProps, QuestionState>
{
    constructor(public props: QuestionProps, public state: QuestionState)
    {
        super(props);

        this.state = initial_state;
    }


    measureHeight = (el: HTMLElement, answered: boolean) =>
    {
        const {answered:sanswered, height:oheight} = this.state;

        if (sanswered !== answered) return;

        if (! el) return;

        const {height:nheight} = el.getBoundingClientRect();

        if (oheight !== nheight) this.setState({ height: nheight });
    };


    /**
     * get response options for the question
     * @returns {JSX.Element[]}
     */
    getOptions = () : JSX.Element[] =>
    {
        return _.map(this.props.question.answers, (answer: IAnswer, i: number) =>
        {
            return <VoiceOver
                        vo={answer.vo}
                        style_name={styles.option}
                        onClick={() => this.chooseAnswer(i)}
                        key={i}>

                {answer.text}

            </VoiceOver>;
        });
    };


    chooseAnswer = (answer: number) =>
    {
        this.setState({ answer: answer, answered: true });

        //TODO  do we want to display a response here for either correct/incorrect/both answers?

        // if (answer === this.props.question.answer) this.props.clearOutageID();
        //
        // this.props.hideModal();
    };


    clearOutage = () =>
    {
        const {clearOutageID, hideModal} = this.props;

        clearOutageID();
        hideModal();
    };


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {outage, question, clearOutageID, hideModal} = this.props;
        const {answer, answered, height} = this.state;

        if (! question) return null;

        const {question:question_text, image, response} = question;
        // const {affects} = outage;
        const affects: string = null;
        const is_correct: boolean = answer === this.props.question.answer;

        return <div styleName={! answered ? 'question-content' : 'answer-content'}>

            <div styleName={'header'}>

                <div styleName={'image'}>

                    <img
                        styleName={'source-image'}
                        src={`./img/game/power-sources/${affects}@2x.png`} />
                    <img
                        styleName={'warning-icon'}
                        src={`./img/game/modals/warning-icon@2x.png`} />

                </div>

            </div>

            <div styleName={'warning'}>

                <p styleName={'warning-text'}><span styleName={'warning-attention'}>attention action needed - </span>Answer a questions to fix your power stations and bring them back online</p>

            </div>

            <div
                styleName={'question-and-answer'} style={{ height: height }}>

                <div
                    styleName={'question-slide'}
                    ref={el => this.measureHeight(el, false)}>

                    <HighlightText type={'yellow'}>question</HighlightText>

                    <h4 styleName={'headline'}>{question_text}</h4>

                    {/*<p styleName={'body-copy'}>{question_text}</p>*/}

                    <div styleName={'options'}>

                        {this.getOptions()}

                    </div>
                </div>

                <div
                    styleName={'answer-slide'}
                    ref={el => this.measureHeight(el, true)}>

                    <HighlightText type={'yellow'}>{is_correct ? 'well done!' : 'wrong answer!'}</HighlightText>

                    <h4 styleName={'headline'}>{question_text}</h4>

                    {/*<p styleName={'body-copy'}>{question_text}</p>*/}

                    <div styleName={'response'}>

                        {response}

                    </div>

                    <div styleName={'answer-footer'}>

                        {is_correct &&
                        <Button
                            type={'right-answer'}
                            onClick={this.clearOutage}>

                            good job!

                        </Button>}

                        {! is_correct &&
                        <Button
                            type={'wrong-answer'}
                            onClick={hideModal}>

                            oh no!

                        </Button>}

                    </div>

                </div>

            </div>

        </div>;
    }
}



/**
 * map the state to props
 * @param state
 */
const mapStateToProps = state =>
{
    return {
        outage: getOutageData(state),
        question: getOutageQuestionData(state),
    }
};


/**
 * map dispatch functions to the component props
 * @param dispatch
 * @returns {{onModeSelect: ((mode: string) => any); onCountrySelect: ((country: string) => any)}}
 */
const mapDispatchToProps = dispatch =>
{
    return {
        clearOutageID: () => dispatch(clearOutageID()),
        hideModal: () => dispatch(hideModal())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(OutageQuestion);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/modals/event-question/OutageQuestion.tsx